import { chatError } from '@/core/types';
/** Maps anything thrown by fetch/WebSocket into the UI's error vocabulary. */
export function toChatError(err) {
    if (err instanceof DOMException && err.name === 'AbortError') {
        return chatError('aborted', 'Request cancelled.', { retryable: false });
    }
    if (err instanceof DOMException && err.name === 'TimeoutError') {
        return chatError('timeout', 'The assistant took too long to reply.', { cause: err });
    }
    if (err instanceof HttpError) {
        // Data mode's refusals say exactly what to do; "session expired" would not.
        const code = errorCode(err);
        if (code.startsWith('data_')) {
            return chatError('unknown', err.message, { retryable: false, cause: err });
        }
        if (err.status === 401 || err.status === 403) {
            return chatError('unauthorized', 'Your session has expired.', { retryable: false, cause: err });
        }
        if (err.status === 429) {
            return chatError('rate_limited', 'Too many messages. Try again in a moment.', {
                retryable: true,
                cause: err,
            });
        }
        if (err.status >= 500) {
            return chatError('server', 'The assistant is unavailable right now.', { cause: err });
        }
        return chatError('unknown', err.message, { retryable: false, cause: err });
    }
    if (err instanceof TypeError) {
        return chatError('network', 'Connection lost. Check your network.', { cause: err });
    }
    return chatError('unknown', err instanceof Error ? err.message : 'Something went wrong.', {
        cause: err,
    });
}
/** The API envelope's `errors[0].code`, or ''. */
export function errorCode(err) {
    const body = err.body;
    const code = Array.isArray(body?.errors) ? body?.errors[0]?.code : undefined;
    return typeof code === 'string' ? code : '';
}
export class HttpError extends Error {
    status;
    body;
    constructor(status, message, body) {
        super(message);
        this.status = status;
        this.body = body;
        this.name = 'HttpError';
    }
}
